import { render, staticRenderFns } from "./InternalChatContact.vue?vue&type=template&id=22479faa&lang=html"
import script from "./InternalChatContact.vue?vue&type=script&lang=js"
export * from "./InternalChatContact.vue?vue&type=script&lang=js"
import style0 from "./InternalChatContact.vue?vue&type=style&index=0&id=22479faa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports